import  { useEffect } from 'react'
import {  useSearchParams } from 'react-router-dom';


export default function Authenticator() {
    const [searchParams,] = useSearchParams();
   
    const token = searchParams.get("token");
    const data = searchParams.get("data");
 
    localStorage.setItem('accessToken',token);
    localStorage.setItem('accounts',data);
    useEffect(()=>{
       window.location.href="https://sdsadmin.dev-bt.xyz/dashboard/home"
       
    })
   
    
   return  ""

  
}
